'use client';
import React, { useEffect, useState } from 'react';

import CartTableRow from './CartTableRow';
import { useAppSelector } from '@/lib/redux/hooks';
import { usePathname } from 'next/navigation';
import CartCoupon from './CartCoupon';
const Cart = ({ cartPage }: { cartPage?: boolean }) => {
  const pathName = usePathname();
  const cartItems = useAppSelector((state) => state.cart.items);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null; // or a loading spinner
  }
  return (
    <div className="cart__product table-responsive">
      <table className="table">
        <thead>
          <tr>
            <th>Product</th>
            <th>Price</th>
            <th>Quantity</th>
            <th>Total</th>
            {pathName === '/wishlist' && <th>Add To Cart</th>}
            <th>Remove</th>
          </tr>
        </thead>
        <tbody>
          {cartItems.length > 0 ? (
            cartItems.map((item, i) => <CartTableRow key={i} product={item} />)
          ) : (
            <tr>
              <td colSpan={6} className="text-center">
                Your cart is empty.
              </td>
            </tr>
          )}
          {cartPage && <CartCoupon />}
        </tbody>
      </table>
    </div>
  );
};

export default Cart;
